export const CREATING_CONSENT = 'CREATING_CONSENT'
